import React, {FC, ReactNode, useState} from 'react';
import {MainContent} from 'src/components/MainLayout/MainContent';
import {MainLayoutFooter} from 'src/components/MainLayout/MainLayoutFooter';
import {Header} from 'src/components/Header/Header';
import {GetLoggedInUser, PortalContext} from "../../hooks/PortalContext";
import {ICompanyAccess} from "../../types/Company";
import {NoAuthLayout} from "./NoAuthLayout";
import {Typography} from "@mui/material";
import {useAuth} from 'src/auth/context';
import {DefaultButton} from "../common/DefaultButton";

export const MainLayout: FC<{ children: ReactNode}> = ({children}) => {
  let savedClientId = localStorage.getItem("client_pub_id");
  const [currentClientId, setCurrentClientId] = useState<string | null>(savedClientId);

  let {user, isLoading} = GetLoggedInUser();

  if (isLoading) {
    return <></>
  }

  // Make sure that the user is enabled before showing the portal
  // A user needs to have at least one company or the portal is useless
  // So if they don't have any companies, show a message and block them going further
  if (!user || !user.userInfo || user.userInfo.disabled || user.accessTo.length === 0) {
    return <NoCompanyOrUser />
  }

  // Find the current client from the list of user roles
  let clientInfo = user.accessTo.find((client: ICompanyAccess) => client.id === currentClientId);
  if(!clientInfo) {
    // If it can't find it, or one hasn't been set, then find the first one
    clientInfo = user.accessTo[0];
    localStorage.setItem("client_pub_id", clientInfo.id);
  }

  let portalContext = {
    clientInfo:clientInfo,
    loggedInUser: user,
    setClient: (client_id : string) => {
        localStorage.setItem("client_pub_id", client_id);
        setCurrentClientId(client_id);
    },
  }

  return (
    <PortalContext.Provider value={portalContext}>
      <Header />
      <MainContent>{children}</MainContent>
      <MainLayoutFooter />
    </PortalContext.Provider>
  );
};

// Message to show when a user doesn't have a company
const NoCompanyOrUser = () => {
  const {logout} = useAuth();

  return (
    <NoAuthLayout>
      <Typography>You don't appear to have an enabled subscription to Detexian. If you feel this is in error, email <a href={"mailto:support@detexian.com"} >support@detexian.com</a></Typography>
      <DefaultButton variant="contained" onClick={() => void logout()} style={{marginTop: '20px'}}>Switch user</DefaultButton>
    </NoAuthLayout>)
}
